import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { FileWarning, Calculator, Clock } from 'lucide-react';

const problems = [
  {
    icon: Calculator,
    title: 'Impostos Confusos',
    desc: 'Garantimos que você pague apenas o necessário, dentro da lei. Sem surpresas no fim do mês.',
  },
  {
    icon: FileWarning,
    title: 'Burocracia Desnecessária',
    desc: 'Cuidamos de toda a papelada, da abertura da empresa à emissão de notas fiscais.',
  },
  {
    icon: Clock,
    title: 'Falta de Tempo',
    desc: 'Você cuida de vender e atender. A gente cuida das obrigações, prazos e impostos. Você só recebe o aviso de pagar ou assinar.',
  },
];

export default function Problems() {
  const sectionRef = useScrollAnimation();

  return (
    <section
      id="problemas"
      data-testid="problems-section"
      ref={sectionRef}
      className="py-24 md:py-32 bg-[#F8FAFC]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Header */}
        <div className="scroll-fade text-center mb-16 md:mb-20">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#10B981] mb-4">
            Problemas que resolvemos
          </p>
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0A2540] tracking-tight leading-tight"
            style={{ fontFamily: "'Inter', sans-serif", letterSpacing: '-1px' }}
          >
            Os desafios que resolvemos para você
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 stagger-children">
          {problems.map((item) => (
            <div
              key={item.title}
              data-testid={`problem-card-${item.title.toLowerCase().replace(/\s/g, '-')}`}
              className="scroll-fade group p-8 md:p-10 bg-white border border-slate-200 rounded-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#10B981]/10 text-[#10B981] mb-6 group-hover:bg-[#10B981] group-hover:text-white transition-colors duration-300">
                <item.icon size={24} />
              </div>
              <h3
                className="text-xl font-bold text-[#0A2540] mb-3"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {item.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
